import { Component, FC } from 'react';
import { ILayout, LAYOUT } from '../types';
import LayoutDefault from './default';
import LayoutLimbic from './limbic';

const map: { [key: string]: typeof Component | FC<any> } = {
  DEFAULT: LayoutDefault,
  LIMBIC: LayoutLimbic,
};

const Layout: FC<ILayout> = (props) => {

  const {
    layout = LAYOUT.LIMBIC,
    title,
    subtitle,
    children,
  } = props;

  const ActiveLayout = map[layout];

  return (
    <ActiveLayout title={title} subtitle={subtitle}>
      {children}
    </ActiveLayout>
  );

};

export default Layout;
